//https://sistemas.ucasal.edu.ar/sagbackend/api/v1/mi-perfil/lovs/tipo-documentos?tdocu=0&ndocu=1
import { SERVICES_URL } from "../../config/config";
import { connection } from "../../utils/connection";


const getListDocumentTypesService = async ({ token, callbacks }) => {
    const response = ["DNI-LE-LC","C.I.","Pasaporte","Otros","D.U."]; //await connection({ method: 'GET', url: `${SERVICES_URL.DOCUMENT_TYPES.LIST}`, token });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default getListDocumentTypesService;
